export const LIST_POLL_MS = 15000;
export const LIVE_POLL_MS = 5000;
export const SHELL_POLL_MS = 30000;

export function startPoll(task, intervalMs) {
  let stopped = false;
  let running = false;
  let first = true;

  const run = async () => {
    if (stopped || running || document.hidden) return;
    running = true;
    const isFirst = first;
    first = false;
    try {
      await task({ first: isFirst });
    } catch (error) {
      console.error(error);
    } finally {
      running = false;
    }
  };

  run();
  const id = window.setInterval(run, intervalMs);
  const onVisibility = () => {
    if (!document.hidden) run();
  };
  document.addEventListener("visibilitychange", onVisibility);

  return () => {
    stopped = true;
    window.clearInterval(id);
    document.removeEventListener("visibilitychange", onVisibility);
  };
}

export function commitIfChanged(cacheRef, next, apply) {
  let key;
  try {
    key = JSON.stringify(next);
  } catch {
    apply(next);
    return true;
  }
  if (cacheRef.current === key) return false;
  cacheRef.current = key;
  apply(next);
  return true;
}
